import React from 'react';
const BG_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/hp-hero-section-bg-img-new-aj9og7tuznq.png';
const HERO_ASSET_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/hero-image-asset-3zr00d8irk.png';
const LOGOS = [{
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-1-7uox6tm8dl3.png',
  alt: 'Brand 1'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-2-tz2mhq4dv1.png',
  alt: 'Brand 2'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-3-lh6i2tsuqjr.png',
  alt: 'Brand 3'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-4-qh95xz1yxuc.png',
  alt: 'Brand 4'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-5-fe93nfq7rdn.png',
  alt: 'Brand 5'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-6-bnjr6o8mjvl.png',
  alt: 'Brand 6'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-7-y8t5opowp.png',
  alt: 'Brand 7'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-8-kvdzezq2byc.png',
  alt: 'Brand 8'
}, {
  url: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/logo-9-4e8beemjuv3.png',
  alt: 'Brand 9'
}];
export const Hero = () => {
  return <section data-name="Hero" data-nav-theme="dark" className="relative w-full">
      {/* Background image */}
      <img src={BG_URL} alt="" loading="eager" className="absolute inset-0 w-full h-full object-cover object-center" />
      {/* Dark scrim so cream text clears AA contrast over the photo */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'linear-gradient(180deg, rgba(9,23,23,0.45), rgba(9,23,23,0.15))'
    }} />

      {/* Content wrapper */}
      <div className="relative z-10 max-w-8xl mx-auto px-4 md:px-6 lg:px-6">

        {/* === Headline + Description two-column === */}
        <div data-name="Headline Block" className="pt-[80px] lg:pt-[180px] flex flex-col lg:flex-row lg:gap-16 lg:items-end">
          {/* Left: Headline */}
          <div data-name="Headline" className="lg:w-[60%] animate-fade-slide-up">
            <h1 className="text-cream leading-[1.05]" style={{
            fontSize: 'clamp(56px, 8.8vw, 120px)'
          }}>
              <span className="font-sans font-normal lg:block">Your store,</span>{' '}
              <span className="font-serif italic lg:block" style={{
              letterSpacing: '-0.02em'
            }}>{"ready for AI"}</span>
            </h1>
          </div>

          {/* Right: Description */}
          <div data-name="Description" className="animate-fade-slide-up-delay-1 mt-4 lg:mt-0 lg:pb-3 lg:ml-auto w-full lg:w-fit mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
            <p className="font-sans text-cream leading-[1.4] lg:max-w-[42ch]" style={{
            fontSize: 'clamp(16px, 1.5vw, 20px)'
          }}>
              The commerce platform that makes your storefront beautiful for shoppers and readable for the AI agents now buying on their behalf.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a href="/book-a-demo" className="inline-block text-center rounded-full bg-cream text-[#091717] font-medium px-6 py-3 text-base" style={{
              transition: 'background-color 0.2s ease'
            }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(252,250,246,0.85)'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#FCFAF6'} data-tracking-id="link-8eb6a7c6e15f6eef">Book a demo</a>
              <a href="/ai-storefront" className="inline-block text-center rounded-full border border-cream text-cream font-medium px-6 py-3 text-base" style={{
              transition: 'opacity 0.2s ease'
            }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.5'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="link-1abb50ff6303df8d">See it in action</a>
            </div>
          </div>
        </div>

        {/* === Editorial store UI image === */}
        <div data-name="Store Preview Image" className="animate-fade-slide-up-delay-2 mt-4 lg:mt-8 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
          <img src={HERO_ASSET_URL} alt="GreatStore — AI-powered storefront preview" loading="eager" {...{
          'fetchpriority': 'high'
        } as {}} className="w-full aspect-video object-cover rounded-2xl rounded-tl-none rounded-tr-none rounded-br-none rounded-bl-none" />
        </div>

        {/* === Trusted bar — text only === */}
        <div data-name="Trusted Bar" className="animate-fade-slide-up-delay-3 mt-8 lg:mt-8 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
          <p style={{
          fontSize: 'clamp(16px, 1.2vw, 20px)'
        }} className="[font-family:Instrument_Sans,sans-serif] font-medium text-cream text-center mb-2 mt-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
            Trusted by brands that care about growth
          </p>
        </div>

      </div>{/* end max-w-8xl */}

      {/* Logo marquee — full width, outside constrained container */}
      {/* Outer: fade animation only — NO overflow-hidden here (Safari stacking context clips child animations) */}
      <div data-name="Logo Marquee" aria-label="Trusted brands" className="animate-fade-slide-up-delay-3 w-full mt-8 pb-12 lg:pb-10 mb-0 ml-0 mr-0 pt-0 pl-0 pr-0">
        {/* Inner: overflow container isolated from the opacity/transform animation layer */}
        <div className="overflow-hidden w-full marquee-overflow">
          <div className="marquee-track">
            {/* Set A */}
            {LOGOS.map((logo, i) => <img key={`a-${i}`} src={logo.url} alt={logo.alt} className="h-[28px] md:h-[36px] lg:h-[50px] w-auto object-contain flex-shrink-0 mx-5 md:mx-10" />)}
            {/* Set B — duplicate for seamless loop */}
            {LOGOS.map((logo, i) => <img key={`b-${i}`} src={logo.url} alt="" aria-hidden="true" className="h-[28px] md:h-[36px] lg:h-[50px] w-auto object-contain flex-shrink-0 mx-5 md:mx-10" />)}
          </div>
        </div>
      </div>
    </section>;
};